import { Component, OnDestroy, OnInit , ViewChild} from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Router, ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as fromStore from '../../store';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { DialogComponent } from '../../dialog/dialog.component';
import { CompanionService } from '../../services/companion.service';
import {
  updateInfoType,
  UpsEventsId,
  CompanionRuleType,
  AuthOtpType,
  AuthOtpDeviceType,
  CompanionType,
  CheckCompanionCodeErrMsg
} from 'src/app/shareModel';
import { UpdateInfoModel } from '../../my-features/updateInfo/update-info.model';
import * as fromFeature from '../../my-features';

@Component({
  standalone: false,
  selector: 'app-confirm-companion',
  templateUrl: './confirm-companion.component.html',
  styleUrls: ['./confirm-companion.component.css'],
})
export class ConfirmCompanionComponent implements OnInit, OnDestroy {
  @ViewChild(DialogComponent, { static: false }) childDialog: DialogComponent;
  private componentDestroyed = new Subject();
  UpdateInfoParam = {} as UpdateInfoModel;
  pathparam = '';
  message: string;
  otpid: number;
  CompanionOfflineNotify: boolean;
  companionEvent = [];
  companionList = [];
  companionDic = [];
  companionGroupList = [];
  companionUsers = 0;
  Status = '';
  Name = '';
  Companion = '';
  Event = '';
  TriggerId = '';
  constructor(
    private ngxService: NgxUiLoaderService,
    private translateService: TranslateService,
    private messageService: MessageService,
    private store: Store<fromStore.State>,
    private router: Router,
    private companionService: CompanionService
  ) {
    this.store.dispatch(new fromFeature.GetCompanions());
    this.store.dispatch(new fromFeature.GetCompanionsOverView());
    this.pathparam = window.location.pathname.substring(window.location.pathname.lastIndexOf('/') + 1, window.location.pathname.length);
    this.store.dispatch(
      new fromFeature.GetCompanionProtectionProcessDevice({otp: '', Hash: this.pathparam})
    );
    this.store
      .select(fromStore.getCompanionProtectionProcessDevice)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res) => {
        if (res !== undefined && res !== null && res.msg !== '') {
        // tslint:disable-next-line:max-line-length
        this.store
          .select(fromStore.getCompanionRuleList)
          .pipe(takeUntil(this.componentDestroyed))
          .subscribe((ruleListRes) => {
            if (ruleListRes !== undefined && ruleListRes.length > 0) {
              this.store
                .select(fromStore.getPlanSettingDevices)
                .subscribe((plan) => {
                  if (plan.isLoaded) {
                    this.companionUsers = 0;
                    this.companionEvent = [];
                    const device = Object.values(plan.entities);
                    this.Name = device.find((d) => d['dcode'] === res.msg.body.dcode)[
                      'name'
                    ];
                    this.TriggerId = res.msg.body.TriggerId;
                    for (let i = 0; i < res.msg.body.Data.length ; i++) {
                      const c = i ;
                      const item = res.msg.body.Data[i];
                      if (item !== undefined) {
                        if (!this.Status.includes(CompanionRuleType[item.Action])) {
                          this.Status += CompanionRuleType[item.Action];
                          if (c + 1 !== res.msg.body.Data.length) {
                            this.Status += '/ ';
                          }
                        }
                        const conpanionName = this.companionList.find(
                          (n) => n.Id === item.CmpnId
                        );
                        if (!this.Companion.includes(conpanionName.Companion)) {
                          this.Companion += conpanionName.Companion;
                          if (c + 1 !== res.msg.body.Data.length) {
                            this.Companion += '/ ';
                          }
                        }
                        if (!this.Event.includes(UpsEventsId[item.Event])) {
                          this.Event += UpsEventsId[item.Event];
                          if (c + 1 !== res.msg.body.Data.length) {
                            this.Event += '/ ';
                          }
                        }
                      }
                    }
                  }
                });
            }
          });
        }
      });
    this.store
      .select(fromStore.getCompanionlist)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res) => {
        if (res !== undefined && res !== null) {
          if (res.length > 0) {
            this.companionList = [];
            res.map((item) => {
              if (item.Devices.length > 0) {
                item.Devices.map((d) => {
                  this.companionList.push({
                    Id: item.Id,
                    Status: CompanionRuleType[item.Status],
                    Companion: item.Name,
                    DeviceDecode: d.decode,
                    PairedDevice: d.Name,
                    DeviceSn: d.dsn,
                    Action: '',
                  });
                });
              } else {
                this.companionList.push({
                  Id: item.Id,
                  Status: CompanionRuleType[item.Status],
                  Companion: item.Name,
                  DeviceDecode: 0,
                  PairedDevice: '',
                  DeviceSn: 0,
                  Action: '',
                });
              }
            });
          }
        }
      });
    // Get Update Info
    this.store
      .select(fromStore.getUpdateInfoState)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res) => {
        if (
          res.type === updateInfoType.ConfirmCompanionProtectionProcess ||
          res.type === updateInfoType.GetCompanionProtectionProcess ||
          res.type === updateInfoType.SendKeyOfCompanionProtectionProcess
          ) {
          if (!res.isLoading && res.isLoaded) {
            if (res.isSaved) {
              if (res.type === updateInfoType.ConfirmCompanionProtectionProcess) {
                this.confirmComapanion();
                // this.messageService.add({ severity: 'success', summary: this.translateService.instant(res.msg) });
                // this.router.navigate(['/companion']);
              } else if (res.type === updateInfoType.SendKeyOfCompanionProtectionProcess) {
                this.messageService.add({ severity: 'success', summary: this.translateService.instant(res.msg) });
                this.router.navigate(['/companion']);
              }
            } else if (!res.isSaved) {
              this.messageService.add({ severity: 'error', summary: this.translateService.instant(res.msg) });
              this.router.navigate(['/dashboard']);
            }
            this.ngxService.stop();
          }
          this.resetUpdateInfoState();
        }
      });
  }

  ngOnInit() {
    this.ngxService.start();
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('body-login');
    body.classList.remove('body-landing');
    body.classList.remove('mobile-toggle');
    this.ngxService.stop();
  }

  cancelComapanionEvent() {
    this.messageService.add({ severity: 'error', summary: this.translateService.instant('Not confirmed.') });
    this.router.navigate(['/dashboard']);
  }

  confirmComapanionEvent() {
    const param = {
      otp: '',
      TriggerId: this.TriggerId,
      From: 1 // Web
    };
    this.store.dispatch(
      new fromFeature.ConfirmCompanionProtectionProcess(param)
    );
  }

  confirmComapanion() {
    const param = {
      otp: '',
      DeviceType: AuthOtpDeviceType.Web,
      AuthType: AuthOtpType.CompanionCode,
    };
    this.store.dispatch(new fromFeature.AddAuthOtp(param));
    setTimeout(() => {
      this.store
      .select(fromStore.getAuthotp)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res) => {
        if (res.Loaded && !res.Loading) {
          if (res.entities !== undefined) {
            if (res.entities.Flag) {
              this.otpid = res.entities.Id;
              this.childDialog.showCompanionCodeAuthDialog('ConfirmCompanionEvent', '');
            } else {
              this.childDialog.dialogType.CompanionCodeDialogType = false;
              this.childDialog.alertCompanionCodeLock();
            }
          }
        } else if (!res.Loaded && res.Loading) {
          if (res.entities !== undefined) {
            this.message = res.entities.message;
          }
        }
      });
    }, 500);
  }

  confrimCompanionCode(result: string) {
    // tslint:disable-next-line: max-line-length
    if (result === CompanionType.Confirm_CompanionEvent) {
      this.ngxService.start();
      const authOtpparam = {
        otp : '',
        authId: Number(this.otpid),
        authType: AuthOtpType.CompanionCode,
        authOtp: this.companionService.GetCompanionCode,
      };
      this.store.dispatch(new fromFeature.CheckAuthOtp(authOtpparam));
      this.store
        .select(fromStore.getCheckAuthOtp)
        .pipe(takeUntil(this.componentDestroyed))
        .subscribe((res) => {
          if (res.Loaded && !res.Loading) {
            if (res.entities.Flag) {
              const sendkeyparam = {
                otp : '',
                TriggerIdList: [this.TriggerId],
                AuthId: Number(this.otpid),
                AuthType: AuthOtpType.CompanionCode,
                From: 1 // Web
              };
              this.store.dispatch(new fromFeature.SendKeyOfCompanionProtectionProcess(sendkeyparam));
              this.childDialog.closeDialog();
              this.ngxService.stop();
            } else {
              this.childDialog.errorMsgCompanionCode = CheckCompanionCodeErrMsg[res.entities.Message];
              if (res.entities.Message === '1' || res.entities.Message === '2') {
                this.childDialog.CompanionCodeOvertime = true;
                if (res.entities.Message === '1') {
                  this.childDialog.companionerrorMsgByLock = true;
                }
                this.ngxService.stop();
              }
              this.childDialog.CompanionCodedialogSaveDirty = true;
              this.ngxService.stop();
            }
          }
        });
    } else if (result === CompanionType.closeCompanionOTPdailog) {
      this.router.navigate(['/companion']);
    }
  }

  ngOnDestroy() {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }

  closeCompanionConfirmOTP() {
    this.childDialog.closeCompanionConfirmOTP = true;
  }

  private resetUpdateInfoState(type: string = updateInfoType.FreeState): void {
    this.UpdateInfoParam = { ...this.UpdateInfoParam, type };
    this.store.dispatch(new fromFeature.UpdateInfoSuccessAction({ ...this.UpdateInfoParam }));
  }
}
